import { FunctionComponent, MutableRefObject } from 'react'
import clsx from 'clsx'
import { Box, Typography } from '@mui/material'
import { useGetTranslation } from '@dxp-module/common'
import { Tooltip } from '../../../../../common/graphql/__generated__/graphql.autogenerated'
import TooltipContainer from '../../../../../common/components/tooltip/TooltipContainer'
import isRepaymentAmount from '../../../../../common/utils/isRepaymentAmount'
import { BreakdownTooltip } from '../../../../../common/model/Breakdown'
import tooltipElementStyles from './tooltipElement.styles'

type TooltipElementProps = {
  index: number
  title: string
  translatedTitle: string
  translationKey: string
  tooltip?: Tooltip | BreakdownTooltip[] | null
  classes?: string
  price: string | number
  suffix?: JSX.Element | ''
  shouldBeFormatted?: boolean | null
  value: number | string
  highlighted?: boolean
  targetRef?: MutableRefObject<undefined>
}

const TooltipElement: FunctionComponent<TooltipElementProps> = ({
  index,
  title,
  translatedTitle,
  translationKey,
  tooltip,
  classes,
  price,
  suffix,
  shouldBeFormatted,
  value,
  highlighted,
  targetRef,
}) => {
  const styles = tooltipElementStyles()
  const getTranslation = useGetTranslation()

  return (
    <Box display="flex" position="relative">
      <Typography
        component="span"
        className={clsx([
          classes,
          { [styles.highlighted]: highlighted },
          styles.label,
        ])}
        data-test={`summary:finance_breakdown_element_title_${index}`}
        dangerouslySetInnerHTML={{ __html: translatedTitle }}
        {...(getTranslation(translationKey) && {
          'data-translationkey': translationKey,
        })}
      />
      <Typography
        component="span"
        className={clsx([
          styles.breakdownSection,
          styles.breakdownSectionBlack,
          {
            [styles.breakdownValue]: shouldBeFormatted,
            [styles.breakdownAlign]: !shouldBeFormatted,
            [styles.repaymentAmount]: isRepaymentAmount(title),
            [styles.highlighted]: highlighted,
          },
        ])}
        variant="body1"
        data-test={`summary:finance_breakdown_element_value_${index}`}
      >
        {value && (
          <>
            {price}
            {suffix}
          </>
        )}
        {tooltip && (
          <TooltipContainer
            index={index}
            tooltip={tooltip}
            className={styles.breakdownTooltip}
            targetRef={targetRef}
          />
        )}
      </Typography>
    </Box>
  )
}

export default TooltipElement
